import { BrowserRouter, Switch, Route } from "react-router-dom";
import App from "view/App";
import Index from "ticket/Index";
import IndexOnsite from "ticket/IndexOnsite";

export default function Router() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/">
          <App />
        </Route>
        <Route exact path="/ticket/:nobooking/:status">
          <Index />
        </Route>
        <Route exact path="/ticket/:nobooking">
          <IndexOnsite />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}
